import * as React from 'react';
const Dates = React.memo((props: {
  data: {
    displayDate: string;
  };
}) => {
  return <div aria-label="ID" className="flex justify-right">
      {props.data.displayDate}
    </div>;
});
Dates.displayName = 'Dates';
export default Dates;